import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        textAlign: 'center',
        p: 3,
      }}
    >
      <Typography variant="h1" component="h1" gutterBottom>
        404
      </Typography>
      <Typography variant="h4" component="h2" gutterBottom>
        페이지를 찾기 불가
      </Typography>
      <Typography variant="body1" color="text.secondary" paragraph>
        요청하신 페이지가 존재하지 않거나 이동되었기 가능
      </Typography>
      <Button
        variant="contained"
        color="primary"
        size="medium"
        onClick={() => navigate('/')}
      >
        홈으로 돌아가기
      </Button>
    </Box>
  );
};

export default NotFound; 